var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewRegistration({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 2.58333V15.4167C0.75 16.4296 1.57042 17.25 2.58333 17.25H15.4167C16.4296 17.25 17.25 16.4296 17.25 15.4167V2.58333C17.25 1.57042 16.4296 0.75 15.4167 0.75H2.58333C1.57042 0.75 0.75 1.57042 0.75 2.58333ZM11.75 6.25C11.75 7.77167 10.5171 9 9 9C7.48292 9 6.25 7.77167 6.25 6.25C6.25 4.73292 7.48292 3.5 9 3.5C10.5171 3.5 11.75 4.73292 11.75 6.25ZM3.5 13.5833C3.5 11.75 7.16667 10.7417 9 10.7417C10.8333 10.7417 14.5 11.75 14.5 13.5833V14.5H3.5V13.5833Z",
    fill: "#14AC63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewRegistration);
export default __webpack_public_path__ + "static/media/NewRegistration.033a5c862bbb0bd9dd066f3ddf1fa635.svg";
export { ForwardRef as ReactComponent };